// extracted by mini-css-extract-plugin
export default {"horizontalRuleItem":"rule-items_horizontalRuleItem__2bqYy","verticalRuleItem":"rule-items_verticalRuleItem__oySfD","placeHolderShimmer":"rule-items_placeHolderShimmer__1dFG4"};